import React, { FC } from 'react';

import classNames from 'classnames';
import { omit, prop } from 'ramda';

import BaseInput from 'components/shared/FormAdapters/FormBase/Input';

import styles from '../Input/index.module.css';
import { IFileInputProps } from './types';

const FileInput: FC<IFileInputProps> = ({
  isError,
  disabled,
  readOnly,
  className,
  placeholder,
  onChange,
  ...props
}) => {
  const defaultInputContainerClasses = classNames(
    styles.inputContainer,
    disabled && prop('inputContainer-disabled', styles),
    isError && prop('inputContainer-isError', styles),
  );

  const defaultInputClasses = classNames(styles.input, readOnly && prop('input-readOnly', styles), className);

  const commonInputProps = {
    ...props,
    className: defaultInputClasses,
    disabled,
    readOnly,
  };

  return (
    <div className={defaultInputContainerClasses}>
      <BaseInput
        {...omit(['value'], commonInputProps)}
        placeholder={placeholder}
        type="file"
        onChange={(event) => {
          onChange(event.target.files?.[0]);
        }}
      />
    </div>
  );
};

export default FileInput;
